export default {
  understandingCreditConsumption: "了解信用點數消費",
  howCreditsAreUsed: "如何使用信用點數：",
  creditsAreConsumed:
    "每當您在平台上執行某些操作時，如搜索潛在客戶、兌換電子郵件或匯出數據，都會消耗信用點數。 每個操作都有一個特定的信用成本，將從您的帳戶餘額中扣除。 下表顯示了每個動作如何使用信用點數的細分。",
  actionFeature: "動作/功能",
  creditsConsumed: "已消耗的信用點數",
  cumulativeUsage: "累計使用量",
  details: "詳情",
  searchingForLeadsConsumes: "搜尋潛在客戶每次搜索會消耗 {count} 個信用點數。",
  redeemingAnEmail: "兌換電子郵件每次兌換使用 {count} 信用點數。",
  addingAContact: "將連絡人添加到清單中會消耗 {count} 個信用點數。",
  exportingLeadsToACSV: "將潛在客戶匯出到CSV將使用 {count} 信用點數。",
  identifyWebVisitors: "{count} 信用點數將用於識別網絡訪問者。",
  gotIt: "知道了！",
  featureSearch: "搜索",
  featureRedeemEmail: "兌換電子郵件",
  featureRedeemPhone: "兌換手機",
  featureExportLeads: "匯出潛在客戶",
  featureWebIdentification: "網絡標識",

  upgradeYourPlanToGrowth: "陞級計畫",
  switchToALowerPlan: "切換到較低的計畫",
  yourCurrentPlanOverview: "您當前的計畫概述",
  topupRate: "儲值信用點數：{count}",
  additionalUserLicense: "附加用戶許可證 x {count}",
  totalAmount: "總金額",
  creditConvertedToTopUp: "信用轉換為充值",
  totalNewCredits: "新信用點數合計",
  totalPayment: "付款總額",
  switchToLowerPlan: "切換到更低的計畫",
  save_up_to:
    "使用此方案最高可節省<span style='color: {color}'>&nbsp;{percent}%&nbsp;</span>！",
};

export const settings_pricing_japanese = {
  understandingCreditConsumption: "クレジット消費の理解",
  howCreditsAreUsed: "クレジットの使用方法:",
  creditsAreConsumed:
    "リードの検索、メールの交換、データのエクスポートなど、プラットフォームで特定のアクションを実行するたびにクレジットが消費されます。各アクションには特定のクレジットコストがあり、アカウント残高から差し引かれます。以下の表は、各アクションがどのようにクレジットを使用するかの内訳を示しています。",
  actionFeature: "アクション/機能",
  creditsConsumed: "消費済みクレジット",
  cumulativeUsage: "累計使用量",
  details: "詳細",
  searchingForLeadsConsumes:
    "リード検索1回につき{count}クレジットを消費します。",
  redeemingAnEmail: "メール交換1回につき{count}クレジットを使用します。",
  addingAContact: "連絡先をリストに追加すると{count}クレジットを消費します。",
  exportingLeadsToACSV:
    "リードをCSVにエクスポートすると{count}クレジットを使用します。",
  identifyWebVisitors: "ウェブ訪問者の識別に{count}クレジットを使用します。",
  gotIt: "了解しました！",
  featureSearch: "検索",
  featureRedeemEmail: "メール交換",
  featureRedeemPhone: "電話番号交換",
  featureExportLeads: "リードエクスポート",
  featureWebIdentification: "ウェブ識別",

  upgradeYourPlanToGrowth: "プランをアップグレード",
  switchToALowerPlan: "低いプランに切り替え",
  yourCurrentPlanOverview: "現在のプラン概要",
  topupRate: "クレジットチャージ：{count}",
  additionalUserLicense: "追加ユーザーライセンス x {count}",
  totalAmount: "合計金額",
  creditConvertedToTopUp: "クレジット転換によるチャージ",
  totalNewCredits: "新規クレジット合計",
  totalPayment: "支払い総額",
  switchToLowerPlan: "低いプランに切り替え",
  save_up_to:
    "このプランで最大<span style='color: {color}'>&nbsp;{percent}%&nbsp;</span>節約可能！",
};

export const settings_pricing_korean = {
  understandingCreditConsumption: "크레딧 소비 이해",
  howCreditsAreUsed: "크레딧 사용 방법:",
  creditsAreConsumed:
    "잠재 고객 검색, 이메일 교환 또는 데이터 내보내기와 같은 플랫폼에서 특정 작업을 수행할 때마다 크레딧이 소비됩니다. 각 작업에는 특정 크레딧 비용이 있으며 계정 잔액에서 차감됩니다. 아래 표는 각 작업이 크레딧을 어떻게 사용하는지에 대한 세부 정보를 보여줍니다.",
  actionFeature: "작업/기능",
  creditsConsumed: "소비된 크레딧",
  cumulativeUsage: "누적 사용량",
  details: "상세 정보",
  searchingForLeadsConsumes:
    "잠재 고객 검색 1회당 {count} 크레딧이 소비됩니다.",
  redeemingAnEmail: "이메일 교환 1회당 {count} 크레딧이 사용됩니다.",
  addingAContact: "연락처를 목록에 추가하면 {count} 크레딧이 소비됩니다.",
  exportingLeadsToACSV:
    "잠재 고객을 CSV로 내보내면 {count} 크레딧이 사용됩니다.",
  identifyWebVisitors: "웹 방문자 식별에 {count} 크레딧이 사용됩니다.",
  gotIt: "알겠습니다!",
  featureSearch: "검색",
  featureRedeemEmail: "이메일 교환",
  featureRedeemPhone: "전화번호 교환",
  featureExportLeads: "잠재 고객 내보내기",
  featureWebIdentification: "웹 식별",

  upgradeYourPlanToGrowth: "플랜 업그레이드",
  switchToALowerPlan: "낮은 플랜으로 전환",
  yourCurrentPlanOverview: "현재 플랜 개요",
  topupRate: "크레딧 충전: {count}",
  additionalUserLicense: "추가 사용자 라이선스 x {count}",
  totalAmount: "총 금액",
  creditConvertedToTopUp: "크레딧 전환 충전",
  totalNewCredits: "신규 크레딧 합계",
  totalPayment: "총 결제 금액",
  switchToLowerPlan: "낮은 플랜으로 전환",
  save_up_to:
    "이 플랜으로 최대 <span style='color: {color}'>&nbsp;{percent}%&nbsp;</span> 절약 가능!",
};

export const settings_pricing_hindi = {
  understandingCreditConsumption: "क्रेडिट खपत को समझें",
  howCreditsAreUsed: "क्रेडिट का उपयोग कैसे किया जाता है:",
  creditsAreConsumed:
    "जब भी आप प्लेटफॉर्म पर कोई क्रिया करते हैं जैसे लीड खोजना, ईमेल रिडीम करना या डेटा एक्सपोर्ट करना, तो क्रेडिट खर्च होते हैं। प्रत्येक क्रिया की एक विशिष्ट क्रेडिट लागत होती है जो आपके खाते की शेष राशि से कटौती की जाती है। नीचे दी गई तालिका प्रत्येक क्रिया द्वारा क्रेडिट उपयोग का विवरण दिखाती है।",
  actionFeature: "क्रिया/फीचर",
  creditsConsumed: "खर्च किए गए क्रेडिट",
  cumulativeUsage: "संचयी उपयोग",
  details: "विवरण",
  searchingForLeadsConsumes:
    "लीड खोजने पर प्रति खोज {count} क्रेडिट खर्च होते हैं।",
  redeemingAnEmail:
    "ईमेल रिडीम करने पर प्रति रिडीम {count} क्रेडिट उपयोग होते हैं।",
  addingAContact: "संपर्क को सूची में जोड़ने पर {count} क्रेडिट खर्च होते हैं।",
  exportingLeadsToACSV:
    "लीड को CSV में एक्सपोर्ट करने पर {count} क्रेडिट उपयोग होते हैं।",
  identifyWebVisitors: "वेब विज़िटर पहचानने पर {count} क्रेडिट उपयोग होते हैं।",
  gotIt: "समझ गया!",
  featureSearch: "खोज",
  featureRedeemEmail: "ईमेल रिडीम",
  featureRedeemPhone: "फोन रिडीम",
  featureExportLeads: "लीड एक्सपोर्ट",
  featureWebIdentification: "वेब पहचान",

  upgradeYourPlanToGrowth: "प्लान अपग्रेड करें",
  switchToALowerPlan: "कम प्लान पर स्विच करें",
  yourCurrentPlanOverview: "आपकी वर्तमान प्लान रूपरेखा",
  topupRate: "क्रेडिट टॉप-अप: {count}",
  additionalUserLicense: "अतिरिक्त उपयोगकर्ता लाइसेंस x {count}",
  totalAmount: "कुल राशि",
  creditConvertedToTopUp: "क्रेडिट रूपांतरित टॉप-अप",
  totalNewCredits: "नए क्रेडिट का कुल योग",
  totalPayment: "कुल भुगतान",
  switchToLowerPlan: "कम प्लान पर स्विच करें",
  save_up_to:
    "इस प्लान से <span style='color: {color}'>&nbsp;{percent}%&nbsp;</span> तक बचत करें!",
};
